module.exports = __webpack_public_path__ + "img/calendar.85f7932d.png";